import csrApi from "../api/serve";
export default {
    state: {
        formData: {
            formTitle: "MSI CSR Report Survey",
            reportList: {
                listTitle: "Select years",
                id: 327645,
                checkItem: [
                    // {
                    //     id: 123,
                    //     group: "report",
                    //     listTitle: "2015 CSR Report",
                    // },
                    // {
                    //     id: 11232,
                    //     listTitle: "2016 CSR Report",
                    //     group: "report",
                    // },
                    // {
                    //     id: 1122,
                    //     listTitle: "2017 CSR Report",
                    //     group: "report",
                    // },
                    {
                        id: 6454,
                        listTitle: "2018 CSR Report",
                        value: "2018_msi_csr",
                        group: "report",
                    },
                    {
                        id: 1987,
                        listTitle: "2019 CSR Report",
                        value: "2019_msi_csr",
                        group: "report",
                    },
                    {
                        id: 34522,
                        listTitle: "2020 CSR Report",
                        value: "2020_msi_csr",
                        group: "report",
                    },
                    {
                        id: 3422,
                        listTitle: "2021 CSR Report",
                        value: "2021_msi_csr",
                        group: "report",
                    },
                    {
                        id: 11112,
                        listTitle: "2022 CSR Report",
                        value: "2022_msi_csr",
                        group: "report",
                    },
                    {
                        id: 199878762,
                        listTitle: "2023 CSR Report",
                        value: "2023_msi_csr",
                        group: "report",
                    },
                    {
                        id: 191119878762,
                        listTitle: "2024 CSR Report",
                        value: "2024_msi_csr",
                        group: "report",
                    },
                    {
                        id: 19162,
                        listTitle: "2025 CSR Report",
                        value: "2025_msi_csr",
                        group: "report",
                    },
                    {
                        id: 453326432,
                        listTitle: "2025 Climate and Nature Report",
                        value: "2025_msi_climate_and_nature",
                        group: "report",
                    },
                    {
                        id: 2467542,
                        listTitle:
                            "2025 MSI Sustainability Report (Issued in 2026)",
                        value: "2025_msi_climate_and_nature_2026_organization",
                        group: "report",
                    },
                ],
            },
            relationList: {
                listTitle: "Your relationship with MSI",
                id: 1,
                checkItem: [
                    {
                        id: 1,
                        group: "relationship",
                        listTitle: "Customer",
                    },
                    {
                        id: 2,
                        listTitle: "Shareholder、Investor",
                        group: "relationship",
                    },
                    {
                        id: 3,
                        listTitle: "Supplier",
                        group: "relationship",
                    },
                    {
                        id: 4,
                        listTitle: "Employee",
                        group: "relationship",
                    },
                    {
                        id: 5,
                        listTitle: "Family of employees",
                        group: "relationship",
                    },
                    {
                        id: 6,
                        listTitle: "Government",
                        group: "relationship",
                    },
                    {
                        id: 7,
                        listTitle: "Academia",
                        group: "relationship",
                    },
                    {
                        id: 8,
                        listTitle: "Investment Institution",
                        group: "relationship",
                    },
                    {
                        id: 9,
                        listTitle: "Competitors",
                        group: "relationship",
                    },
                    {
                        id: 10,
                        listTitle: "NGOs",
                        group: "relationship",
                    },
                    {
                        id: 11,
                        listTitle: "Others",
                        group: "relationship",
                    },
                ],
            },
            ageList: {
                listTitle: "Your age",
                id: 2,
                checkItem: [
                    {
                        id: 1,
                        group: "age",
                        listTitle: "< 30",
                    },
                    {
                        id: 2,
                        listTitle: "30-50",
                        group: "age",
                    },
                    {
                        id: 3,
                        listTitle: "> 50",
                        group: "age",
                    },
                ],
            },
            concernList: {
                listTitle:
                    "What's your concern about the following material topics?",
                checkItem: [
                    {
                        itemTitle: "Business Performance",
                        id: 1,
                        checklist: [
                            {
                                id: 1,
                                group: "Business_Performance",
                                listTitle: "High",
                            },
                            {
                                id: 2,
                                group: "Business_Performance",
                                listTitle: "Normal",
                            },
                            {
                                id: 3,
                                group: "Business_Performance",
                                listTitle: "Low",
                            },
                        ],
                    },
                    {
                        itemTitle: "Corporate Governance",
                        id: 2,
                        checklist: [
                            {
                                id: 1,
                                group: "Corporate_Governance",
                                listTitle: "High",
                            },
                            {
                                id: 2,
                                group: "Corporate_Governance",
                                listTitle: "Normal",
                            },
                            {
                                id: 3,
                                group: "Corporate_Governance",
                                listTitle: "Low",
                            },
                        ],
                    },
                    {
                        itemTitle: "Corporate Image",
                        id: 3,
                        checklist: [
                            {
                                id: 1,
                                group: "Corporate_Image",
                                listTitle: "High",
                            },
                            {
                                id: 2,
                                group: "Corporate_Image",
                                listTitle: "Normal",
                            },
                            {
                                id: 3,
                                group: "Corporate_Image",
                                listTitle: "Low",
                            },
                        ],
                    },
                    {
                        itemTitle: "Risk Management",
                        id: 4,
                        checklist: [
                            {
                                id: 1,
                                group: "Risk_Management",
                                listTitle: "High",
                            },
                            {
                                id: 2,
                                group: "Risk_Management",
                                listTitle: "Normal",
                            },
                            {
                                id: 3,
                                group: "Risk_Management",
                                listTitle: "Low",
                            },
                        ],
                    },
                    {
                        itemTitle: "Sustainable Environment Management",
                        id: 5,
                        checklist: [
                            {
                                id: 1,
                                group: "Sustainable_Environment_Management",
                                listTitle: "High",
                            },
                            {
                                id: 2,
                                group: "Sustainable_Environment_Management",
                                listTitle: "Normal",
                            },
                            {
                                id: 3,
                                group: "Sustainable_Environment_Management",
                                listTitle: "Low",
                            },
                        ],
                    },
                    {
                        itemTitle: "Labour Relations",
                        id: 6,
                        checklist: [
                            {
                                id: 1,
                                group: "Labour_Relations",
                                listTitle: "High",
                            },
                            {
                                id: 2,
                                group: "Labour_Relations",
                                listTitle: "Normal",
                            },
                            {
                                id: 3,
                                group: "Labour_Relations",
                                listTitle: "Low",
                            },
                        ],
                    },
                    {
                        itemTitle: "Product Management",
                        id: 7,
                        checklist: [
                            {
                                id: 1,
                                group: "Product_Management",
                                listTitle: "High",
                            },
                            {
                                id: 2,
                                group: "Product_Management",
                                listTitle: "Normal",
                            },
                            {
                                id: 3,
                                group: "Product_Management",
                                listTitle: "Low",
                            },
                        ],
                    },
                    {
                        itemTitle: "Supplier Management",
                        id: 8,
                        checklist: [
                            {
                                id: 1,
                                group: "Supplier_Management",
                                listTitle: "High",
                            },
                            {
                                id: 2,
                                group: "Supplier_Management",
                                listTitle: "Normal",
                            },
                            {
                                id: 3,
                                group: "Supplier_Management",
                                listTitle: "Low",
                            },
                        ],
                    },
                    {
                        itemTitle: "Regulatory Compliance",
                        id: 9,
                        checklist: [
                            {
                                id: 1,
                                group: "Regulatory_Compliance",
                                listTitle: "High",
                            },
                            {
                                id: 2,
                                group: "Regulatory_Compliance",
                                listTitle: "Normal",
                            },
                            {
                                id: 3,
                                group: "Regulatory_Compliance",
                                listTitle: "Low",
                            },
                        ],
                    },
                ],
            },
            materiality: {
                listTitle:
                    "Other materiality topics ? Please fill out the topic.(Option)",
            },
            auth: {
                listTitle: "Authentication Code",
            },
            googleFormLink: {
                title: "eng",
                text: "eng",
                linkTitle: "eng",
                link: "",
            },
            notice: {
                title: "",
                list: [
                    {
                        content: "eng",
                        mailLink: "",
                    },
                    {
                        content: "eng",
                        mailLink: "csr@msi.com.tw",
                    },
                ],
            },
        },
        MandarinFormData: {
            formTitle: "MSI 永續報告書下載",
            reportList: {
                listTitle: "選擇發行年度",
                id: 327645,
                checkItem: [
                    // {
                    //     id: 123,
                    //     group: "report",
                    //     listTitle: "2015 CSR Report",
                    // },
                    // {
                    //     id: 11232,
                    //     listTitle: "2016 CSR Report",
                    //     group: "report",
                    // },
                    // {
                    //     id: 1122,
                    //     listTitle: "2017 CSR Report",
                    //     group: "report",
                    // },
                    {
                        id: 6454,
                        listTitle: "2018 CSR Report",
                        value: "2018_msi_csr_ch",
                        group: "report",
                    },
                    {
                        id: 1987,
                        listTitle: "2019 CSR Report",
                        value: "2019_msi_csr_ch",
                        group: "report",
                    },
                    {
                        id: 34522,
                        listTitle: "2020 CSR Report",
                        value: "2020_msi_csr_ch",
                        group: "report",
                    },
                    {
                        id: 522,
                        listTitle: "2021 CSR Report",
                        value: "2021_msi_csr_ch",
                        group: "report",
                    },
                    {
                        id: 11112,
                        listTitle: "2022 CSR Report",
                        value: "2022_msi_csr_ch",
                        group: "report",
                    },
                    {
                        id: 4512,
                        listTitle: "2023 CSR Report",
                        value: "2023_msi_csr_ch",
                        group: "report",
                    },
                    {
                        id: 4512222,
                        listTitle: "2024 CSR Report",
                        value: "2024_msi_csr_ch",
                        group: "report",
                    },
                    {
                        id: 66432,
                        listTitle: "2025 CSR Report",
                        value: "2025_msi_csr_ch",
                        group: "report",
                    },
                    {
                        id: 6126432,
                        listTitle: "2025 Climate and Nature Report",
                        value: "2025_msi_climate_and_nature_ch",
                        group: "report",
                    },
                    {
                        id: 267542,
                        listTitle:
                            "2025 MSI Sustainability Report (Issued in 2026)",
                        value: "2025_msi_climate_and_nature_2026_organization_ch",
                        group: "report",
                    },
                ],
            },
            relationList: {
                listTitle: "您的身份",
                id: 432,
                checkItem: [
                    {
                        id: 123,
                        group: "relationship",
                        listTitle: "客戶",
                    },
                    {
                        id: 11232,
                        listTitle: "股東、投資人",
                        group: "relationship",
                    },
                    {
                        id: 112332,
                        listTitle: "供應商",
                        group: "relationship",
                    },
                    {
                        id: 112132,
                        listTitle: "員工",
                        group: "relationship",
                    },
                    {
                        id: 1142232,
                        listTitle: "員工眷屬",
                        group: "relationship",
                    },
                    {
                        id: 1125732,
                        listTitle: "政府機構",
                        group: "relationship",
                    },
                    {
                        id: 110232,
                        listTitle: "學術單位",
                        group: "relationship",
                    },
                    {
                        id: 187961232,
                        listTitle: "投資機構",
                        group: "relationship",
                    },
                    {
                        id: 5611232,
                        listTitle: "同業",
                        group: "relationship",
                    },
                    {
                        id: 2311232,
                        listTitle: "非營利組織",
                        group: "relationship",
                    },
                    {
                        id: 153321232,
                        listTitle: "其他",
                        group: "relationship",
                    },
                ],
            },
            ageList: {
                listTitle: "請問您的年齡?",
                id: 432122,
                checkItem: [
                    {
                        id: 123,
                        group: "age",
                        listTitle: "< 30歲",
                    },
                    {
                        id: 11232,
                        listTitle: "30-50歲",
                        group: "age",
                    },
                    {
                        id: 132,
                        listTitle: "> 50歲",
                        group: "age",
                    },
                ],
            },
            concernList: {
                listTitle: "請問您對下列議題的關注程度 ?",
                checkItem: [
                    {
                        itemTitle: "企業營運績效",
                        id: 3412232,
                        checklist: [
                            {
                                id: 123,
                                group: "Business_Performance",
                                listTitle: "High",
                            },
                            {
                                id: 11232,
                                group: "Business_Performance",
                                listTitle: "Normal",
                            },
                            {
                                id: 132,
                                group: "Business_Performance",
                                listTitle: "Low",
                            },
                        ],
                    },
                    {
                        itemTitle: "公司治理概況",
                        id: 3432,
                        checklist: [
                            {
                                id: 123,
                                group: "Corporate_Governance",
                                listTitle: "High",
                            },
                            {
                                id: 11232,
                                group: "Corporate_Governance",
                                listTitle: "Normal",
                            },
                            {
                                id: 132,
                                group: "Corporate_Governance",
                                listTitle: "Low",
                            },
                        ],
                    },
                    {
                        itemTitle: "企業品牌形象",
                        id: 23432,
                        checklist: [
                            {
                                id: 123,
                                group: "Corporate_Image",
                                listTitle: "High",
                            },
                            {
                                id: 11232,
                                group: "Corporate_Image",
                                listTitle: "Normal",
                            },
                            {
                                id: 132,
                                group: "Corporate_Image",
                                listTitle: "Low",
                            },
                        ],
                    },
                    {
                        itemTitle: "企業風險管理",
                        id: 348632,
                        checklist: [
                            {
                                id: 123,
                                group: "Risk_Management",
                                listTitle: "High",
                            },
                            {
                                id: 11232,
                                group: "Risk_Management",
                                listTitle: "Normal",
                            },
                            {
                                id: 132,
                                group: "Risk_Management",
                                listTitle: "Low",
                            },
                        ],
                    },
                    {
                        itemTitle: "環境永續管理",
                        id: 34985332,
                        checklist: [
                            {
                                id: 123,
                                group: "Sustainable_Environment_Management",
                                listTitle: "High",
                            },
                            {
                                id: 11232,
                                group: "Sustainable_Environment_Management",
                                listTitle: "Normal",
                            },
                            {
                                id: 132,
                                group: "Sustainable_Environment_Management",
                                listTitle: "Low",
                            },
                        ],
                    },
                    {
                        itemTitle: "勞資關係",
                        id: 34211132,
                        checklist: [
                            {
                                id: 123,
                                group: "Labour_Relations",
                                listTitle: "High",
                            },
                            {
                                id: 11232,
                                group: "Labour_Relations",
                                listTitle: "Normal",
                            },
                            {
                                id: 132,
                                group: "Labour_Relations",
                                listTitle: "Low",
                            },
                        ],
                    },
                    {
                        itemTitle: "產品管理",
                        id: 349732,
                        checklist: [
                            {
                                id: 123,
                                group: "Product_Management",
                                listTitle: "High",
                            },
                            {
                                id: 11232,
                                group: "Product_Management",
                                listTitle: "Normal",
                            },
                            {
                                id: 132,
                                group: "Product_Management",
                                listTitle: "Low",
                            },
                        ],
                    },
                    {
                        itemTitle: "供應商管理",
                        id: 342232132,
                        checklist: [
                            {
                                id: 123,
                                group: "Supplier_Management",
                                listTitle: "High",
                            },
                            {
                                id: 11232,
                                group: "Supplier_Management",
                                listTitle: "Normal",
                            },
                            {
                                id: 132,
                                group: "Supplier_Management",
                                listTitle: "Low",
                            },
                        ],
                    },
                    {
                        itemTitle: "法規符合性",
                        id: 34320987,
                        checklist: [
                            {
                                id: 123,
                                group: "Regulatory_Compliance",
                                listTitle: "High",
                            },
                            {
                                id: 11232,
                                group: "Regulatory_Compliance",
                                listTitle: "Normal",
                            },
                            {
                                id: 132,
                                group: "Regulatory_Compliance",
                                listTitle: "Low",
                            },
                        ],
                    },
                ],
            },
            materiality: {
                listTitle: "其它重大議題? 煩請說明.(選填)",
            },
            auth: {
                listTitle: "驗證碼",
            },
            googleFormLink: {
                title: "微星利害關係人永續議題調查",
                text: "為蒐集利害關係人意見，敬請填寫微星科技永續發展議題-利害關係人調查",
                linkTitle: "點我填寫",
                link: "https://docs.google.com/forms/d/e/1FAIpQLSdZ0Hx6mFbVkyf5gzwre1dQKNlwGyHN4tneK3THUM9EKGa28w/viewform",
            },
            notice: {
                title: "備註:",
                list: [
                    {
                        content:
                            "微星永續報告年度為揭露發行年度前一年之ESG績效",
                        mailLink: "",
                    },
                    {
                        content:
                            "欲閱覽2018年或以前之報告書，請來信微星永續發展辦公室索取",
                        mailLink: "csr@msi.com.tw",
                    },
                ],
            },
        },
        captcha: {},
        formListResult: "",
    },
    mutations: {
        setCaptcha(state, captcha) {
            state.captcha = captcha;
        },
        setFormListResult(state, result) {
            state.formListResult = result;
        },
    },
    actions: {
        currentLang({ commit }, lang) {
            commit("setCurrentLang", lang);
        },
        async fetchCaptcha({ commit }) {
            try {
                const response = await csrApi.get("/get/captcha");
                commit("setCaptcha", response.data.captcha);
            } catch (err) {
                console.log("err", err);
            }
        },
        async postFormList({ commit }, listData) {
            try {
                const response = await csrApi.post("/post/survey", listData);
                commit("setFormListResult", response.data);
            } catch (err) {
                console.log("err", err);
            }
        },
    },
    getters: {
        getFormData(state, rootState) {
            if (rootState.getCurrentLang === "global") {
                return state.formData;
            } else {
                return state.MandarinFormData;
            }
        },
        getCaptcha(state) {
            return state.captcha;
        },
        getFormListResult(state) {
            return state.formListResult.message;
        },
        getPDFLink(state) {
            return state.formListResult.pdf.pdf_file;
        },
    },
    modules: {},
};
